import { useEffect, useRef, useState } from "react";
import { isCanceled } from "../api/client";

export default function useMutation({ uncertainOnFailure = false } = {}) {
  const pending = useRef(null);
  const [state, setState] = useState({ busy: false, error: "", result: null, cooldown: 0, uncertain: false });
  useEffect(() => () => pending.current?.abort(), []);
  useEffect(() => {
    if (!state.cooldown) return;
    const timer = setInterval(() => {
      if (Date.now() >= state.cooldown) setState((value) => ({ ...value, cooldown: 0 }));
    }, 1000);
    return () => clearInterval(timer);
  }, [state.cooldown]);
  const run = async (work) => {
    if (pending.current || state.cooldown || state.uncertain) return null;
    const controller = new AbortController();
    pending.current = controller;
    setState((value) => ({ ...value, busy: true, error: "", result: null }));
    try {
      const result = await work(controller.signal);
      if (!controller.signal.aborted) setState((value) => ({ ...value, busy: false, result }));
      return controller.signal.aborted ? null : result;
    } catch (error) {
      if (!controller.signal.aborted && !isCanceled(error)) {
        const uncertain = uncertainOnFailure && (!error.status || error.status >= 500);
        setState({ busy: false, result: null, uncertain,
          error: uncertain ? "نتیجه ارسال مشخص نیست. پیش از ارسال مجدد وضعیت را از پشتیبانی بررسی کنید." : error.message,
          cooldown: error.status === 429 ? Date.now() + (error.retryAfterMs ?? 60000) : 0 });
      }
      return null;
    } finally { if (pending.current === controller) pending.current = null; }
  };
  return { ...state, run, disabled: state.busy || Boolean(state.cooldown) || state.uncertain };
}
